@if (alertErro === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/error.png" width="82px" alt="Erro">
      <p class="titulo-alert mt-4 mb-4"> {{ alertErroTitulo }} </p>
      <p class="mensagem-alert mb-4 mx-2"> {{ alertErroMensagem }} </p>
      <div class="footer-alert mt-4 bg-danger">
        <button class="botao-cancelar-outline" (click)="fecharAlertErro()" id="fecharAlertErro"> {{ alertErroBotao }} </button>
      </div>
    </div>
  </div>
}
